export function getBodyPreviewHtml(bodyText: string, samples: string[] = []) {
  return bodyText.replace(/\{\{(\d+)\}\}/g, (match, p1) => {
    const idx = parseInt(p1, 10) - 1;
    return samples[idx] !== undefined && samples[idx] !== ""
      ? samples[idx]
      : match;
  });
}
